import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import QRCode from 'react-qr-code';
import arcelik from 'src/assets/images/arcelik.svg';
import beko from 'src/assets/images/beko.svg';

const useStyles = makeStyles(() => ({
  root: {},
  pcServiceItem: {
    display: 'block',
    color: '#222222',
    textAlign: 'center',
    padding: 2,
    backgroundColor: '#fe9e24',
  },
  pcServiceItemT: {
    fontSize: 10,
    marginBottom: 3,
  },
  pcServiceItemV: {
    fontSize: 7,
  },
  items: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  item: {
    marginRight: 10,
    width: '30%',
  },
  pcCard: {
    boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)',
    backgroundColor: '#efefef',
  },
  pcImg: {
    paddingTop: '100%',
    position: 'relative',
    '& img': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      margin: 'auto',
      inset: 0,
      objectFit: 'cover',
    },
  },
  pcContent: {
    position: 'relative',
    padding: '26px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  pcLeftT: {
    fontSize: '18px',
    fontWeight: 500,
    marginBottom: '3px',
  },
  pcLeftV: {
    fontSize: '12px',
    lineHeight: 1.3,
  },
  pcRight: {
    marginTop: '-4rem',
    textAlign: 'center',
  },
  pcQr: {
    marginBottom: '5px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    width: '6rem',
    height: '6rem',
  },
  pcRightT: {
    fontSize: '15px',
  },
}));
function PersonalCard({ openUserCard, setOpenUserCard, user }) {

  const classes = useStyles();
  const capitalizeFirstLetter = (wordsString) => {
    const wordsArray = wordsString.split(" ");
    return wordsArray.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
  }

  return (
    <div>
      <Dialog
        open={openUserCard}
        onClose={() => setOpenUserCard(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <div className={classes.items}>
            <img src={arcelik} alt="Arçelik" className={classes.item} />
            <div className={`${classes.pcServiceItem} ${classes.item}`}>
              <Typography variant="h5">
                Yetkili<br />Servis
              </Typography>
              <Typography variant="h6">
                0850 210 08 88
              </Typography>
            </div>
            <img src={beko} alt="Beko" className={classes.item}></img>
          </div>
        </DialogContent>
        <DialogContent className={classes.pcCard} style={{ textAlign: 'center' }}>
          <div className={classes.pcImg}>
            <img src={user.avatar} alt="Personel" />
          </div>
          <div className={classes.pcContent}>
            <div>
              <Typography variant="h6" className={classes.pcLeftT}>
                {capitalizeFirstLetter(user.name)}
              </Typography>
              <Typography variant="body1" className={classes.pcLeftV}>
                Teknisyen<br />
                {user.TechnicianCode}
              </Typography>
            </div>
            <div className={classes.pcRight}>
              <div className={classes.pcQr}>
              <QRCode value={capitalizeFirstLetter(user.name) + '-' + capitalizeFirstLetter(user.bio)} size={80}/>
              </div>
              <Typography variant="h6" className={classes.pcRightT}>
                {capitalizeFirstLetter(user.bio)}
              </Typography>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenUserCard(false)} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default PersonalCard;
